module.exports = __webpack_public_path__ + "static/media/brightness.59f88d83.svg";